import React from 'react';

import Flow from '../flow/Flow';
import ConfigList from '../config-list/ConfigList';

import type { FlowInputOutput } from '../../types/flows.types';

import './FlowDashboard.css';

export const FlowDashboardView: React.FC<{
  flow: FlowInputOutput[];
  entities: unknown[];
  subId: string;
  selectedIdx: number;
  onGotoNode: (type: string, id: string) => void;
  onHoverNode: (idOrParams: string | { node: string }) => void;
}> = ({ flow, entities, subId, selectedIdx, onGotoNode, onHoverNode }) => (
  <div className="flow-dashboard">
    <div className="flow-dashboard__flow">
      <Flow
        autoSelectMainNode
        flow={flow}
        onGotoNode={onGotoNode}
        onHoverNode={onHoverNode}
        mainNodeId={flow[selectedIdx].data._id}
      />
    </div>
    <div className="flow-dashboard__config">
      <ConfigList
        objectList={flow.map((c) => c.data)}
        subId={subId}
        entities={entities}
        selectedIdx={selectedIdx}
        scrollToSelected
      />
    </div>
  </div>
);
